import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { adminApi, formatApiError } from "@/lib/adminApi";

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const EMPTY = { full_name: "", phone: "", email: "", address: "" };

export const validateClient = (f) => {
  const e = {};
  if (f.full_name.trim().length < 2) e.full_name = "Enter the client's full name";
  if (f.phone.replace(/\D/g, "").length < 7 || !/^\+?[\d\s().-]+$/.test(f.phone.trim())) e.phone = "Enter a valid phone number";
  if (!EMAIL.test(f.email.trim())) e.email = "Enter a valid email address";
  return e;
};

export const ClientFields = ({ form, setForm, errors, prefix }) => {
  const field = (k, label, opts = {}) => (
    <label className="st-field">
      <span className="st-label">{label}</span>
      <input className={`st-input ${errors[k] ? "is-error" : ""}`} value={form[k]} onChange={(e) => { const v = e.target.value; setForm((f) => ({ ...f, [k]: v })); }}
        data-testid={`${prefix}-${k.replace("_", "-")}-input`} {...opts} />
      {errors[k] && <span className="st-error" data-testid={`${prefix}-${k.replace("_", "-")}-error`}>{errors[k]}</span>}
    </label>
  );
  return (
    <div className="st-form">
      {field("full_name", "Full name *", { autoFocus: true })}
      <div className="st-form st-form--2">
        {field("phone", "Phone *", { type: "tel" })}
        {field("email", "Email *", { type: "email" })}
      </div>
      {field("address", "Project address (optional)")}
    </div>
  );
};

export const AddClientDialog = ({ open, onOpenChange, onCreated }) => {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const errs = validateClient(form);
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setBusy(true);
    try {
      const { data } = await adminApi.post("/studio/clients", { ...form, address: form.address || null });
      setForm(EMPTY);
      onCreated(data);
    } catch (err) {
      setErrors({ form: formatApiError(err.response?.data?.detail, "Could not add the client") });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="st-dialog sm:max-w-[560px]" data-testid="add-client-dialog">
        <DialogTitle>Add New Client</DialogTitle>
        <DialogDescription className="st-muted" style={{ marginTop: -6 }}>Only the essentials for now. Everything else comes later.</DialogDescription>
        <form onSubmit={submit} noValidate style={{ display: "grid", gap: 20, marginTop: 8 }}>
          <ClientFields form={form} setForm={setForm} errors={errors} prefix="add-client" />
          {errors.form && <p className="st-error" data-testid="add-client-form-error">{errors.form}</p>}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button type="button" className="st-btn st-btn--ghost" onClick={() => onOpenChange(false)} data-testid="add-client-cancel-button">Cancel</button>
            <button type="submit" className="st-btn" disabled={busy} data-testid="add-client-submit-button">{busy ? "Adding…" : "Add client"}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
